<template>
    <div>
        <el-button size="mini"
                   icon="el-icon-refresh-right"
                   @click="refresh"
                   :loading="loading">
            重新載入
        </el-button>
        <el-button
                @click="showFilter = !showFilter"
                :icon="showFilter ? 'el-icon-remove-outline': 'el-icon-circle-plus-outline'"
                size="mini"
                type="success"
        >
            過濾器
        </el-button>
        <el-collapse-transition>
            <el-card
                    shadow="never"
                    style="margin: 2px 0;"
                    v-if="showFilter"
            >
                <el-form :model="filter" label-width="120px">
                    <el-row>
                        <el-col :xl="6">
                            <el-form-item label="教室">
                                <el-select
                                        clearable
                                        multiple
                                        placeholder="請選擇教室(多選)"
                                        v-model="filter.roomIds"
                                        filterable
                                >
                                    <el-option
                                            :key="r.ncutRoomId"
                                            :label="r.name + (r.isHidden ? '（已隱藏）' : '')"
                                            :value="r.ncutRoomId"
                                            v-for="r in rooms"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="8">
                            <el-form-item label="申請日期起訖">
                                <el-date-picker
                                        end-placeholder="請選擇結束日期"
                                        range-separator="到"
                                        start-placeholder="請選擇開始日期"
                                        type="daterange"
                                        v-model="filter.range"
                                        value-format="yyyy-MM-dd"
                                        :picker-options="{firstDayOfWeek:1}"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="6">
                            <el-form-item label="狀態">
                                <el-select
                                        clearable
                                        multiple
                                        placeholder="請選擇狀態"
                                        v-model="filter.states"
                                >
                                    <el-option
                                            :key="s.value"
                                            :label="s.label"
                                            :value="s.value"
                                            v-for="s in formStates"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="24">
                            <el-form-item label="簽核者">
                                <el-select
                                        clearable
                                        multiple
                                        placeholder="請選擇簽核者"
                                        v-model="filter.signers"
                                >
                                    <el-option
                                            :key="s.userId"
                                            :label="s.name"
                                            :value="s.userId"
                                            v-for="s in signers"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </el-collapse-transition>
        <el-divider v-if="showFilter">分隔線</el-divider>
        <el-table
                :stripe="true"
                :data="pagedForms"
                empty-text="本學期無表單"
                size="small"
                height="620px"
                row-key="formNo"

        >
            <el-table-column
                    label="表單編號"
                    prop="formNo">
            </el-table-column>
            <el-table-column
                    label="申請時間"
                    prop="createdAt"
            ></el-table-column>
            <el-table-column
                    label="申請人"
            >
                <template #default="{row}">
                    {{ row.applicant | prettyUsernameFull}}
                </template>
            </el-table-column>
            <el-table-column
                    label="教室"
            >
                <template #default="{row}">
                    {{roomName(row)}}
                </template>
            </el-table-column>
            <el-table-column
                    label="簽核者"
            >
                <template #default="{row}" >
                    <span v-if="row.signer.userId">
                         {{ row.signer | prettyUsernameFull}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column
                    label="狀態"
                    prop="status"
            >
            </el-table-column>
            <el-table-column
                    label="操作"
            >
                <template #default="{row}">
                    <el-button
                            type="primary"
                            @click="selectAndShow(row)"
                            size="small"
                    >
                        詳細
                    </el-button>
                    <el-button
                            type="danger"
                            @click="deleteForm(row)"
                            size="small"

                    >直接刪除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :current-page.sync="currentPage"
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="filteredForms.length"
                :page-size="pageSize"
                @current-change="page => pageChange(page, filteredForms)"
        ></el-pagination>
        <el-dialog
                :visible.sync="show"
                :title="title"
                top="5vh"
                v-if="show"
        >
            <form-detail :form="selectedForm"></form-detail>
            <div v-if="isDenied">
                <el-divider>退件原因</el-divider>
                <div style="margin-bottom: 10px;">
                    <el-input
                            :value="denyReason"
                            type="textarea"
                            disabled
                    ></el-input>
                </div>
            </div>
            <template #footer>
                <el-button @click="show = false">關閉</el-button>
            </template>
        </el-dialog>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import formTableMixin from '../../formTableMixin';
    import {Weekdays} from '../../constants';
    import {groupBy} from '../../utilities';
    import moment from 'moment';

    const defaultFilter = {
        roomIds: [],
        range: undefined,
        states: [],
        signers:[],
    };
    export default {
        name: 'BookingManage',
        data: () => ({
            pageSize: 12,
            showFilter: false,
            filter: {...defaultFilter},
        }),
        computed: {
            ...mapState('manage', ['forms']),
            ...mapState('setting', ['rooms']),
            filteredForms(){
                const {roomIds, range, states, signers} = this.filter;
                return this
                    .forms
                    .filter(f =>
                        roomIds.length === 0 || roomIds.some(r => r === f.roomId))
                    .filter(f =>
                        (!range || range.length === 0 || moment(f.createdAt)
                                .isBetween(range[0], range[1], 'd', '[]')
                        )
                    )
                    .filter(f =>
                        states.length === 0 || states.some(s => s === f.state))
                    .filter(f =>
                        signers.length === 0 || signers.some(s => s === f.signer.userId)
                    )
                    ;
            },
            weekdays() {
                return [...Array(7).keys()].map(w => ({
                    key: w + 1,
                    label: Weekdays[w + 1]
                }));
            },
            periodOpts() {
                return [...Array(17).keys()].map(p => ({
                    key: p + 1,
                    label: `第${p + 1}節`,
                    value: p + 1
                }))
            },
            formStates(){
                return [
                    {value: 0, label :'審核中'},
                    {value: 1, label :'審核通過'},
                    {value: 2, label :'取消申請'},
                    {value: 3, label :'退回'},
                ];
            },
            signers() {
                const grpBy = groupBy(this.forms.filter(f => f.signer.userId).map(f => f.signer), s => s.userId);
                const keys = Object.keys(grpBy);
                return keys.reduce((ary, k) => [...ary, grpBy[k][0]], []);
            }
        },
        mixins: [formTableMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            ...mapActions('manage', {
                getForms: 'getFormsAction',
                deleteFormOf: 'deleteFormAction',
            }),

            async deleteForm({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?(刪除後將不能回復)', {
                        type: 'danger',
                    });
                    const {success} = await this.deleteFormOf(id);

                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async refresh() {
                await this.getForms();
            },

            toWeekdayFmt(weekday){
                return  Weekdays[weekday];
            },

            roomName({roomName, roomId}) {
                const room = this.rooms.find(r => r.ncutRoomId === roomId);
                return roomName + (room && room.isHidden ? '（已隱藏）' : '');
            }
        }
        ,
        watch: {
            filteredForms(current){
                this.pagedForms = this.pageData(current, 1);
                this.currentPage = 1;
            }
        }
        ,
        async created() {
            await this.getForms();
        }
    }
</script>

<style>

</style>
